import {Component, EventEmitter, Input, Output} from '@angular/core';
import {AuthService} from "../../../Services/auth.service";
import {ApiServiceService} from "../../../Services/api-service.service";
import {BsModalRef, BsModalService} from "ngx-bootstrap/modal";
import {TaxCalculatorService} from "../../../Services/assessments/tax-calculator.service";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import * as alertify from "alertifyjs";
@Component({
  selector: 'app-first-time-password-change',
  templateUrl: './first-time-password-change.component.html',
  styleUrls: ['./first-time-password-change.component.css']
})
export class FirstTimePasswordChangeComponent {

  @Output() onConfirmClicked = new EventEmitter();
  @Input() email: string;
  verifyForm: any = FormGroup;
  login:  boolean = false;
  errorMessage: string;


  ngOnInit(): void {
    this.verifyForm = this.fb.group({
      old: ["", [Validators.required]],
      password: ["", [Validators.required]],
      confirm: ["", [Validators.required]],
    });
  }

  close() {
    this.onConfirmClicked.emit();
  }

  constructor(
      private authenticationService: AuthService,
      private apiService: ApiServiceService,
      private fb: FormBuilder,
      private bsModalService: BsModalService,
      private bsModalRef: BsModalRef,
  ) {
  }

  submit() {
      console.log(this.verifyForm.value);
      if (!this.checkPassword()) return;
      const url = '/auth/reset-password/first-time?email=' + this.email + '&newPassword=' + this.verifyForm.value.password + '&oldPassword=' + this.verifyForm.value.old;
      this.apiService.loginPost_(url, {}).subscribe((response) => {
        this.authenticationService.logout();
        this.bsModalRef.hide();
        alertify.set('notifier', 'position', 'top-right');
        alertify.warning(response.message);
      }, (error) => {
        alertify.warning("Old password is incorrect. Please try again");
      });
    }

  checkPassword() {
    if (this.verifyForm.value.password !== this.verifyForm.value.confirm) {
      this.errorMessage = "Passwords do not match";
      return false;
    }
    this.errorMessage = "";
    return true;
  }
}
